import axios from 'axios';
import { BASE_URL } from '../Helpers';
import { SitemapGenerator } from './sitemapGenerator';

export class WebhookService {
  
  // Webhook para regenerar sitemap cuando se crea/edita una propiedad
  static async triggerSitemapRegeneration(trigger = 'manual') {
    try {
      console.log(`🔄 Iniciando regeneración de sitemap (trigger: ${trigger})`);
      
      // Usar el generador compatible con el frontend
      const sitemapContent = await SitemapGenerator.generateSitemapContent();
      
      // Enviar al backend para guardar (opcional)
      try {
        await axios.post(`${BASE_URL}/sitemap/update`, {
          content: sitemapContent,
          trigger: trigger
        });
      } catch (backendError) {
        console.log('⚠️  Backend no disponible, continuando con notificación...');
      }
      
      // Notificar a Google/Bing
      await this.notifySearchEngines();
      
      console.log('✅ Sitemap regenerado exitosamente');
      return { success: true, message: 'Sitemap regenerado' };
      
    } catch (error) {
      console.error('❌ Error regenerando sitemap:', error);
      return { success: false, error: error.message };
    }
  }
  
  // Notificar a motores de búsqueda
  static async notifySearchEngines() {
    return await SitemapGenerator.submitToSearchEngines();
  }
  
  // Hook para cuando se publica una nueva propiedad
  static async onPropertyPublished(propertyId) {
    console.log(`🏠 Nueva propiedad publicada: ${propertyId}`);
    return await this.triggerSitemapRegeneration('property_published');
  }
  
  // Hook para cuando se edita una propiedad
  static async onPropertyUpdated(propertyId) {
    console.log(`📝 Propiedad actualizada: ${propertyId}`);
    return await this.triggerSitemapRegeneration('property_updated');
  }
  
  // Hook para cuando se elimina una propiedad
  static async onPropertyDeleted(propertyId) {
    console.log(`🗑️  Propiedad eliminada: ${propertyId}`);
    return await this.triggerSitemapRegeneration('property_deleted');
  }
  
  // Hook automático con debounce (evitar múltiples regeneraciones)
  static debounceTimer = null;
  static async triggerWithDebounce(delay = 30000) { // 30 segundos
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    
    this.debounceTimer = setTimeout(async () => {
      await this.triggerSitemapRegeneration('debounced');
      this.debounceTimer = null;
    }, delay);
  }
}